import { useEffect, useState } from 'react'
import { isBrowser } from '@jelly/utils'

/**
 * Custom hook checking if user scrolled past a pixel mark vertically
 * @function usePastScrollYMark
 * @param {number} YScrollMark - number scroll mark, if past it return true, else false
 */
export const usePastScrollYMark = (YScrollMark) => {
	const [isPastY, setScrollY] = useState(false)
	useEffect(() => {
		if (!isBrowser()) {
			return false
		}
		const handleScroll = () => setScrollY(window.pageYOffset >= YScrollMark)
		window.addEventListener('scroll', handleScroll)

		return () => {
			window.removeEventListener('scroll', handleScroll)
		}
	})
	return isPastY
}

export default usePastScrollYMark
